import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04cf681a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
import { AppStore } from '@apparatix/stores/AppStore';
import Loader from './Loader.vue';
import IframeWrapper from './IframeWrapper.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'IframeLoader',
    setup(__props) {
        const onFrameLoaded = () => AppStore.isFrameLoading = false;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(Loader, {
                    loading: _unref(AppStore).isFrameLoading
                }, null, 8, ["loading"]),
                _withDirectives(_createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AppStore).loadedFrames, (frame) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                            key: frame.url
                        }, [
                            (!frame.isExpired && frame.url !== '')
                                ? _withDirectives((_openBlock(), _createBlock(IframeWrapper, {
                                    key: 0,
                                    src: frame.url,
                                    "loaded-callback": onFrameLoaded,
                                    "provide-jquery": _unref(AppStore).activeSubPage.isIframed
                                }, null, 8, ["src", "provide-jquery"])), [
                                    [_vShow, _unref(AppStore).activeFrameUrl === frame.url]
                                ])
                                : _createCommentVNode("", true)
                        ], 64));
                    }), 128))
                ], 512), [
                    [_vShow, !_unref(AppStore).activeSubPage.isCategoryHome && !_unref(AppStore).showPageNotImplemented]
                ])
            ], 64));
        };
    }
});
